
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Picker from 'vux/src/components/picker/index.vue'

import DateFormatter from '../../../tools/dateFormatter'
export default{
components: {
PopupPicker,
Popup,
Picker
},
directives: {
TransferDom
},
props: {
defaultSelectIndex: Number,
contactList: Array
},
data() {
return {
show: false,
innerContactList: [],
selectContact: [],
selectContactName: ''
}
},
methods: {
pickerSureBtnClick() {
this.$emit('onClickSureBtn', this.selectContact[0])
this.show = false
},
change(value) {
this.selectContactName = this.innerContactList[0][parseInt(value[0])]['name']
}
},
watch: {
show: function (val, oldVal) {
if (val) {
let tempArr = []
for (let i = 0, length = this.contactList.length; i < length; i++) {
let value = this.contactList[i]
tempArr.push({
name: value,
value: i
})
}
this.innerContactList = [tempArr]
this.selectContact = [this.innerContactList[0][this.defaultSelectIndex]['value']]
this.selectContactName = this.contactList[this.defaultSelectIndex]
}
}
},
mounted() {
}
}



// WEBPACK FOOTER //
// ./src/components/views/common/xy-contact-picker.vue